import classes from "./ActivityEditor.module.css";
import settingsClasses from "../PlatformSetting/Settings.module.css";
import {
    ATTENDANCE_DETAILS_SETTINGS_DESCRIPTION,
    POLL_DETAILS_SETTINGS_DESCRIPTION,
    POLL_TYPE,

} from "../../utils/constants";
import React, {useEffect, useRef, useState} from "react";
import {ReactComponent as INFO_ICON} from "../../images/info_icon.svg"

import ActivityEditorConfigurationSectionA from "./ActivityEditorConfigurationSectionA";
import ActivityEditorConfigurationSectionB from "./ActivityEditorConfigurationSectionB";

export default function ActivityEditorConfiguration({draftActivity, setDraftActivity, courseList, userSettings, hasReleased=false}) {
    const columnLayoutStyle = {width: "100%", display: "flex", flexDirection: "column"};

    return (
        <div className={classes.questionMainContainer} >
            <span className={settingsClasses.cardDescription}>
                {draftActivity.pollType === POLL_TYPE.ATTENDANCE
                    ? ATTENDANCE_DETAILS_SETTINGS_DESCRIPTION
                    : POLL_DETAILS_SETTINGS_DESCRIPTION
                }
            </span>

            {hasReleased &&
                <div style={columnLayoutStyle}>
                    <div className={settingsClasses.settingLabel}>{"Enabled Configurations"}</div>
                    <span style={{border: "1px solid #E0E0E0", width: "100%", margin: "5px 0"}}></span>
                </div>
            }


            <ActivityEditorConfigurationSectionA
                draftActivity={draftActivity}
                setDraftActivity={setDraftActivity}
                userSettings={userSettings}
                hasReleased={hasReleased}
            />

            {hasReleased &&
                <div style={{...columnLayoutStyle, marginTop: 20}}>
                    <div className={settingsClasses.settingLabel}>{"Disabled Configurations"}</div>
                    <span style={{border: "1px solid #E0E0E0", width: "100%", margin: "5px 0"}}></span>
                </div>
            }

            {hasReleased &&
                <div className={classes.disabledNotification} style={{marginBottom: 0}}>
                    <INFO_ICON className={classes.infoIcon} style={{flexShrink: 0}}/>
                    <span>
                        <span className={classes.title} style={{marginRight: 5}}>
                            {"Editing Disabled:"}
                        </span>
                        <span>
                            {draftActivity.pollType === POLL_TYPE.ATTENDANCE
                                ? "Configurations cannot be edited once you release the attendance."
                                : "Configurations cannot be edited once you release the poll."
                            }
                        </span>
                    </span>
                </div>
            }

            <ActivityEditorConfigurationSectionB
                draftActivity={draftActivity}
                setDraftActivity={setDraftActivity}
                userSettings={userSettings}
                courseList={courseList}
                hasReleased={hasReleased}
            />

        </div>
    );
}